import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiStudentSetPassword, apiStudentVerifyPassword } from '../lib/studentApi';
import { useStudentSession } from '../context/StudentContext';

export default function StudentSetPassword() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { setSession } = useStudentSession();

  const { email = '', phone = '', name = '' } = (location.state as any) || {};
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');

  if (!email || !phone) {
    navigate('/student/login');
    return null;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await apiStudentSetPassword(email, phone, password);
      // Auto sign-in after setting password
      const res = await apiStudentVerifyPassword(email, password);
      setSession({ studentId: res.studentId, name: res.name, email: res.email, mentorId: res.mentorId, course: res.course, studentToken: res.studentToken });
      navigate('/student/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#f5f5f5' }}>
      <div className="w-full max-w-sm mx-4">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4" style={{ background: '#2b2240' }}>
            <span className="text-2xl font-black" style={{ color: '#F0B429' }}>VT</span>
          </div>
          <h1 className="text-2xl font-black" style={{ color: '#2b2240' }}>Welcome, {name || 'Student'}!</h1>
          <p className="text-sm text-gray-500 mt-1">Set your password to get started</p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-5">
            <p className="text-xs text-blue-700 font-medium">
              This is your first login. Create a password you'll use every time you sign in.
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">New Password</label>
              <input
                type="password" required value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Minimum 6 characters"
                className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-yellow-400"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Confirm Password</label>
              <input
                type="password" required value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Repeat your password"
                className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl text-sm focus:outline-none focus:border-yellow-400"
              />
            </div>
            {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full py-3 rounded-xl text-sm font-bold text-white disabled:opacity-50"
              style={{ background: '#2b2240' }}>
              {loading ? 'Setting password…' : 'Set Password & Enter Dashboard'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
